import { LanguageCodeEditorEnum } from '@/models/CodeEditorActivity';
import {
  CodeValidationResult as ValidationResult,
  CodeValidationResultEnum,
} from '@/models/CodeValidationResult';
import { fadeIn } from '@/utils/animations/commom';
import { motion } from 'motion/react';
import CodeResult from './CodeResult';

type CodeResultsProps = {
  results: ValidationResult[];
  sourceCode: string;
  language: LanguageCodeEditorEnum;
};

export function CodeValidationResult({
  results,
  sourceCode,
  language,
}: CodeResultsProps) {
  function handleStatus(
    status: CodeValidationResultEnum,
  ): CodeValidationResultEnum {
    switch (status) {
      case CodeValidationResultEnum.ACCEPTED:
        return CodeValidationResultEnum.ACCEPTED;
      default:
        return CodeValidationResultEnum.WRONG_ANSWER;
    }
  }

  return (
    <motion.ul
      className="w-full max-h-[20rem] overflow-y-auto overflow-x-hidden flex flex-col gap-2.5"
      {...fadeIn}
    >
      {results.map((result, index) => (
        <CodeResult
          key={index}
          result={result}
          index={index}
          status={handleStatus(result.status.description)}
          sourceCode={sourceCode}
          language={language}
        />
      ))}
    </motion.ul>
  );
}
